// extracted by css-extract-rspack-plugin
export default {"Text":"use-select-panel-module__Text__qmTEXhV"};